@if (form) {
  <div [formGroup]="form" class="astral-form-stack">
    <astral-layout-group [columns]="4" [tabletColumns]="2" [mobileColumns]="1">
      <astral-select
        [control]="leasePeriod"
        [itemsSource]="leasePeriods"
        [helpText]="'LEASE_AGREEMENT_NOTICE_PERIOD_FORM.HELP_TEXT.LEASE_PERIOD_LABEL'"
      ></astral-select>

      @if (showAllowEarlyTermination) {
        <astral-checkbox
          [control]="form.controls['allowEarlyTermination']"
          [helpText]="'LEASE_AGREEMENT_NOTICE_PERIOD_FORM.HELP_TEXT.ALLOW_EARLY_TERMINATION'"
        ></astral-checkbox>
      }

      @if (showProlongation) {
        <astral-input
          [control]="prolongationTime"
          [type]="'number'"
          [inputMode]="'numeric'"
          [supplementalLabel]="'LEASE_AGREEMENT_NOTICE_PERIOD_FORM.MONTH_TEXT'"
        ></astral-input>
      }

      <astral-input
        [control]="tenantDuration"
        [type]="'number'"
        [inputMode]="'numeric'"
        [supplementalLabel]="'LEASE_AGREEMENT_NOTICE_PERIOD_FORM.MONTH_TEXT'"
      ></astral-input>

      <astral-input
        [control]="landlordDuration"
        [type]="'number'"
        [inputMode]="'numeric'"
        [supplementalLabel]="'LEASE_AGREEMENT_NOTICE_PERIOD_FORM.MONTH_TEXT'"
      ></astral-input>
    </astral-layout-group>

    <astral-layout-group [columns]="4" [tabletColumns]="2" [mobileColumns]="1">
      <app-date-picker
        [form]="form.controls['from']"
        [title]="'LEASE_AGREEMENT_NOTICE_PERIOD_FORM.FROM_DATE_LABEL'"
        [model]="from"
        (valueChange)="fromChanged($event)"
        [isRequired]="true"
        [helpText]="'LEASE_AGREEMENT_NOTICE_PERIOD_FORM.HELP_TEXT.FROM_DATE_LABEL'"
      ></app-date-picker>

      @if (showToDate) {
        <app-date-picker
          [form]="form.controls['to']"
          [title]="'LEASE_AGREEMENT_NOTICE_PERIOD_FORM.TO_DATE_LABEL'"
          [model]="to"
          [isRequired]="showToDate"
          (valueChange)="toChanged($event)"
        ></app-date-picker>
      }

      @if (showLastDebitDate) {
        <app-date-picker
          [form]="form.controls['lastDebit']"
          [title]="'LEASE_AGREEMENT_NOTICE_PERIOD_FORM.LAST_DEBIT_DATE_LABEL'"
          [model]="lastDebit"
          (valueChange)="lastDebitChanged($event)"
          [helpText]="'LEASE_AGREEMENT_NOTICE_PERIOD_FORM.HELP_TEXT.LAST_DEBIT_DATE_LABEL'"
          [isRequired]="showLastDebitDate"
        ></app-date-picker>
      }

      @if (showLastDebitDate) {
        <app-date-picker
          [form]="form.controls['desiredMoveOutDate']"
          [title]="'TERMINATE_LEASE_AGREEMENT_FORM.DESIRED_REMOVAL_LABEL'"
          [model]="desiredMoveOutDate"
        ></app-date-picker>
      }
    </astral-layout-group>

    @if (showLastDebitDate) {
      <astral-layout-group [columns]="4" [tabletColumns]="2" [mobileColumns]="1">
        <app-date-picker
          [form]="form.controls['terminationDate']"
          [title]="'TERMINATE_LEASE_AGREEMENT_FORM.TERMINATED_DATE_LABEL'"
          [model]="terminationDate"
          [isRequired]="showLastDebitDate"
        ></app-date-picker>

        <astral-select [control]="terminatedBy" [itemsSource]="terminatedBySelection"></astral-select>
      </astral-layout-group>
    }

    @if (showProlongation) {
      <astral-layout-group [columns]="4" [tabletColumns]="2" [mobileColumns]="1">
        @if (dataContext.validContractPeriodFromLandlord && dataContext.validContractPeriodToLandlord) {
          <app-text-box-readonly
            [caption]="'LEASE_AGREEMENT.VALID_CURRENT_CONTRACT_PERIOD_FROM'"
            [text]="dataContext.validContractPeriodFromLandlord"
          ></app-text-box-readonly>
        }

        @if (dataContext.validContractPeriodToLandlord) {
          <app-text-box-readonly
            [caption]="'LEASE_AGREEMENT.VALID_CURRENT_CONTRACT_PERIOD_TO'"
            [text]="dataContext.validContractPeriodToLandlord"
          ></app-text-box-readonly>
        }

        @if (dataContext.latestTerminationDateLandlord) {
          <app-text-box-readonly
            [caption]="'LEASE_AGREEMENT.LATEST_TERMINATION_DATE'"
            [text]="dataContext.latestTerminationDateLandlord"
          ></app-text-box-readonly>
        }
      </astral-layout-group>
    }
  </div>
}
